import React from 'react';
import {
  MenuItem, MenuItemIcon, MenuItemText,
} from '@picsio/ui';

const Option = ({
  value, selected, option, ...other
}) => (
  <Choose>
    <When condition={value === 'separator'}>
      <MenuItem variant="select" disabled ellipsis {...other} separator />
    </When>
    <Otherwise>
      <MenuItem data-value={value} icon="start" variant="select" selected={selected} ellipsis {...other}>
        <MenuItemIcon size="md">
          {option.icon}
        </MenuItemIcon>
        <MenuItemText primary={option.text} />
      </MenuItem>
    </Otherwise>
  </Choose>
);

export default Option;
